import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../layout/icons/Icons';
import styles from './DataPrivacy.module.css';

const sections = [
  {
    id: 'answers',
    title: 'What happens to your answers',
    body: [
      'August Says saves your answers and an interview session identifier. We use OpenAI models accessed through Microsoft Azure AI Foundry to help conduct the interview and analyse responses, including themes, sentiment and emotion. AI interpretations may be inaccurate.',
    ],
  },
  {
    id: 'review',
    title: 'Human review and improvement',
    body: [
      'The August Says team reviews responses to prepare research findings and reporting for this study.',
      'With your separate permission, we may also reuse your responses to develop and improve August Says\u2019 interview experience and reporting capabilities, both for this study and across clients. You can participate without agreeing to this additional use.',
    ],
  },
  {
    id: 'organisation',
    title: 'What our clients receive',
    body: [
      'The organisation that invited you receives research reports and relevant excerpts from interviews conducted for its study. The current reporting service does not provide it with full interview transcripts.',
      'August Says retains the underlying interview records. Relevant excerpts may identify you through their content or context.',
    ],
  },
  {
    id: 'identity',
    title: 'Protecting your identity',
    body: [
      'We do not ask for your name or contact details in this interview. Please avoid including information that could identify you or anyone else. Because answers are free text, we cannot guarantee that every response is anonymous. We retain interview records for 12 months.',
    ],
  },
  {
    id: 'choices',
    title: 'Your choices and requests',
    body: [
      'Participation is voluntary, and you can end the interview at any time. Ending the interview does not automatically delete answers already submitted.',
      ' August Says may also reuse your responses for human review and development to improve its interview experiences and reports across clients.',
      'We do not maintain a directory linking participants\u2019 names or email addresses to their interviews. We may therefore be unable to locate your answers from your name or email address alone.',
      'For questions or requests about your information, contact our privacy team at privacy@augustsays.com.',
      // <>We retain interview records for 12 months. Read the <Link to="/data-privacy">full Interview Privacy Notice</Link> for details about the organisations responsible for this research, access to responses, analysis across studies, human review, service providers, international processing and your applicable rights.</>,
    ],
  },
];

const DataPrivacy = () => {
    const [agreed, setAgreed] = useState(() => {
        try {
        return !!window?.localStorage?.getItem('augustsays_privacy_agreed');
        } catch {
        return false;
        }
    });

    const handleAgree = () => {
        try {
        window?.localStorage?.setItem('augustsays_privacy_agreed', new Date().toISOString());
        } catch {}
    };

    const handleDecline = () => {
        try {
        window?.localStorage?.removeItem('augustsays_privacy_agreed');
        } catch {}
    };

  return (
    <div className={styles.page}>
      <main>
        <nav className={`${styles.nav} ${styles.shell}`} aria-label="Primary navigation">
          <a className={styles.wordmark} href="#top" aria-label="August Says home">
            <Icon name="augustsays/logo" color="currentColor" height="32" width="61" />
            <span className={styles.wordmarkText}>August Says</span>
          </a>
          {/* <div className={styles.navLinks}>
            <a href="#notice">Privacy notice</a>
            <a href="#choices">Your choices</a>
          </div> */}
        </nav>

        <section className={`${styles.hero} ${styles.shell}`} id="top">
          <div className={styles.eyebrow}>Data privacy</div>
          <h1>Your experience<br /><em>matters.</em></h1>
          <p className={styles.heroCopy}>An AI-guided interview powered by August Says.</p>
          {/* <p className={styles.heroSupport}>Your responses help better understand participants' experiences and perspectives.</p> */}
        </section>

        <section className={styles.privacySection} id="notice">
          <div className={`${styles.shell} ${styles.narrow}`}>
            <div className={styles.sectionNumber}>01 — Privacy notice</div>
            <div className={styles.cards}>
              {sections.map((s, idx) => (
                <article className={styles.card} key={s.id}>
                  <div className={styles.cardNumber}>{String(idx + 1).padStart(2, '0')}</div>
                  <h2 className={styles.cardTitle}>{s.title}</h2>
                  <div className={styles.cardBody}>
                    {s.body.map((content, i) => {
                      if (typeof content === 'string') {
                        return <p key={`${s.id}-${i}`}>{content}</p>;
                      }
                      return <div key={`${s.id}-${i}`}>{content}</div>;
                    })}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* <section className={styles.choicesSection} id="choices">
          <div className={`${styles.shell} ${styles.narrow}`}>
            <div className={styles.sectionNumber}>02 — Your participation choices</div>
            <div className={styles.consentCard}>
              <label className={styles.checkboxRow}>
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                />
                <span className={styles.checkboxText}>
                  Optional: I agree that August Says may also reuse my responses for human review and development to improve its interview experience and reporting for this study and across clients.
                </span>
              </label>
              <p className={styles.consentText}>
                By selecting &ldquo;Agree and begin,&rdquo; I consent to August Says collecting and analysing my responses for the research described in my invitation and the Interview Privacy Notice, and providing relevant excerpts and reports to the organisation that invited me.
              </p>
              <div className={styles.buttons}>
                <button
                  type="button"
                  className={styles.buttonPrimary}
                  disabled={!agreed}
                  onClick={handleAgree}
                >
                  Agree and begin
                </button>
                <button type="button" className={styles.buttonSecondary} onClick={handleDecline}>
                  Decline
                </button>
              </div>
            </div>
          </div>
        </section> */}

        <footer className={styles.footer}>
          <div className={`${styles.shell} ${styles.footerInner}`}>
            <a className={`${styles.wordmark} ${styles.footerMark}`} href="#top" aria-label="August Says home">
              <Icon name="augustsays/logo" color="currentColor" height="32" width="61" />
              <span className={styles.wordmarkText}>August Says</span>
            </a>
            <p>Organizational signal intelligence.</p>
            <p>© 2026 August Says</p>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default DataPrivacy;
